import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { breakpoint } from '~/styles/themes';

export const Container = styled.div`
  ${({ theme }) => css`
    display: flex;
    position: fixed;
    z-index: ${theme.zIndex.modal};
    top: 50%;
    left: 50%;
    flex-direction: column;
    flex-direction: 8px;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    min-width: 280px;
    max-width: ${breakpoint.mobile_large};
    height: 100%;
    overflow: hidden;
    transform: translate(-50%, -50%) translate(-0.5px, -0.5px);
    will-change: translate;
  `}
`;

export const Inner = styled.div`
  display: flex;
  position: absolute;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  gap: 20px;
  padding: 16px 0;
`;

export const Background = styled.div`
  ${({ theme }) => css`
    display: flex;
    position: fixed;
    z-index: ${theme.zIndex.background};
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    overflow: hidden;
    border-radius: 16px;
    background: ${theme.backgroundColor.bg_dark_5_alpha};
  `}
`;

export const ClueNote = styled.div`
  position: relative;
  min-width: 280px;
  max-width: 360px;
  height: 80%;
  max-height: 570px;
`;

export const ClueNotePaperBackground = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: top;
`;

export const Content = styled.div`
  display: flex;
  position: absolute;
  top: 0;
  left: 0;
  flex-direction: column;
  height: 100%;
  padding: 24px;
  gap: 24px;
`;

export const ClueTitle = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ClueListBox = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 16px;
  height: 100%;
  overflow-y: auto;
  ${({ theme }) => theme.mixins.scroll.none}
`;

export const ClueList = styled.li`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const ClueDesc = styled.div`
  ${({ theme }) => css`
    padding: 8px 4px;
    border-radius: 8px;
    background: ${theme.backgroundColor.bg_light_5_alpha};
    backdrop-filter: blur(10px);
  `}
`;

export const CloseButtonBox = styled.div`
  ${({ theme }) => css`
    display: block;

    & > button {
      display: block;
      width: 180px;
      height: 44px;
      border-radius: 22px;
      background: ${theme.backgroundColor.bg_light_1};
    }
  `}
`;
